export const partMap = (parts) => Object.entries(parts)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(' ');
export const nfCapitalize = (string) => {
    return string.split(" ").map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
};
